import Screen from '../../../../shared/utils/screen';
import FlavourConfig from '../../../../shared/config/flavours';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import { MenuItemProps as Props } from '../../../../shared/types/props/menu';

const MenuSelector = styled.img<Props>`
  left: ${40 * Screen.widthRatio}px;
  padding-top: ${6 * Screen.widthRatio}px;
  position: absolute;
  width: ${16 * Screen.widthRatio}px;
`;

MenuSelector.defaultProps = {
  src: FlavourConfig.images.menuSelector,
};

export default withAnimation(withImage(MenuSelector, false));
